import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { hayvancılikApi as hayvancilikApi, tanimlarApi } from '../services/api';
import DataTable, { DtColumn } from '../components/DataTable';
import { GUNCEL_AY, cozGuncelAy } from '../utils/guncelAy';

const AYLAR = ['', 'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
               'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
const YIL = new Date().getFullYear();

const emptyForm = {
  isletme_id: '', yil: YIL, ay: new Date().getMonth() + 1, irk_kod: '',
  boga_sayisi: 0, inek_sayisi: 0, genc_boga_sayisi: 0, duve_sayisi: 0,
  dana_erkek: 0, dana_disi: 0,
  erkek_buzagi_sayisi: 0, disi_buzagi_sayisi: 0,
  ticari_sigir_sayisi: 0, reforme_sayisi: 0,
  sut_uretimi_kg: 0, ana_hayvan_sayisi: 0, sagmal_hayvan_sayisi: 0,
  buzagi_dogum: 0, buzagi_olum: 0,
  damizlik_satis: 0, besi_satis: 0, aciklama: ''
};

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

// Tanımlar API'den liste çek
async function getTanimlar(modul: string) {
  const res = await fetch(`${API}/api/tanimlar2/liste?modul=${modul}&sadece_yaprak=true`, { headers: headers() });
  return res.ok ? res.json() : [];
}

export default function Buyukbas() {
  const [kayitlar, setKayitlar] = useState<any[]>([]);
  const [isletmeler, setIsletmeler] = useState<any[]>([]);
  const [ozet, setOzet] = useState<any>(null);
  const [secili, setSecili] = useState<any>(null);
  const [modalAcik, setModalAcik] = useState(false);
  const [form, setForm] = useState<any>({ ...emptyForm });
  const [filtre, setFiltre] = useState((() => {
    const sp = new URLSearchParams(window.location.search);
    return {
      isletme_id: sp.get('isletme') || '',
      yil: Number(sp.get('yil') || YIL),
      ay: sp.get('ay') || GUNCEL_AY
    };
  })());
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);
  const [excelMesaj, setExcelMesaj] = useState('');
  const [cakismaModal, setCakismaModal] = useState(false);
  const [cakismalar, setCakismalar] = useState<any[]>([]);
  const [cakismaYeniSayisi, setCakismaYeniSayisi] = useState(0);
  const [bekleyenDosya, setBekleyenDosya] = useState<File | null>(null);

  // Tanımlar'dan gelen listeler
  const [irklar, setIrklar] = useState<any[]>([]);
  const [gruplar, setGruplar] = useState<any[]>([]);

  const userStr = localStorage.getItem('user');
  const user = userStr ? JSON.parse(userStr) : null;
  const isGM = user?.rol && ['super_admin', 'gm_yonetici', 'gm_personel'].includes(user.rol);
  const isAdmin = user?.rol && ['super_admin', 'gm_yonetici'].includes(user.rol);

  const [kiralikGoster, setKiralikGoster] = useState(false);

  useEffect(() => {
    if (!isGM && user?.isletme_id) {
      setFiltre(f => ({ ...f, isletme_id: user.isletme_id }));
      setForm(f => ({ ...f, isletme_id: user.isletme_id }));
    }
    // Irk listesi: buyukbas_irk modülündeki yaprak düğümler
    getTanimlar('buyukbas_irk').then(setIrklar);
    // Grup listesi: buyukbas_grup modülündeki yaprak düğümler
    getTanimlar('buyukbas_grup').then(setGruplar);
  }, []);

  useEffect(() => {
    tanimlarApi.isletmelerListesi(kiralikGoster).then(r => setIsletmeler(r.data));
  }, [kiralikGoster]);

  useEffect(() => { yukle(); }, [filtre]);

  const [cozulenAy, setCozulenAy] = useState<number | null>(null);

  const yukle = async () => {
    let ay: any = filtre.ay;
    if (ay === GUNCEL_AY) {
      ay = await cozGuncelAy(filtre.yil, filtre.isletme_id, hayvancilikApi.buyukbasList);
      setCozulenAy(ay);
    } else {
      setCozulenAy(null);
    }
    const params: any = { yil: filtre.yil };
    if (filtre.isletme_id) params.isletme_id = filtre.isletme_id;
    if (ay) params.ay = ay;
    hayvancilikApi.buyukbasList(params).then(r => setKayitlar(r.data)).catch(() => setKayitlar([]));
    hayvancilikApi.buyukbasOzet({ yil: filtre.yil, ...(filtre.isletme_id ? { isletme_id: filtre.isletme_id } : {}), ...(ay ? { ay } : {}) })
      .then(r => setOzet(r.data)).catch(() => setOzet(null));
  };

  // Irk kodundan adı bul
  const irkAdi = (kod: string) => {
    const bulunan = irklar.find(i => i.kod === kod);
    return bulunan ? bulunan.ad : kod;
  };

  // DB'de büyük harfle kayıtlı eski irk adlarını tanımlar listesinden düzelt
  const irkAdDuzelt = (ad: string) => {
    if (!ad) return ad;
    const norm = (s: string) => s
      .replace(/İ/g, 'i').replace(/I/g, 'i').replace(/Ş/g, 's')
      .replace(/Ğ/g, 'g').replace(/Ö/g, 'o').replace(/Ü/g, 'u').replace(/Ç/g, 'c')
      .toLowerCase()
      .replace(/\s*-\s*/g, '-').replace(/\s+/g, ' ').trim();
    const normAd = norm(ad);
    const bulunan = irklar.find((i: any) => norm(i.ad) === normAd);
    return bulunan ? bulunan.ad : ad;
  };

  const duzenleAc = (k: any) => {
    let irk_kod = k.irk_kod || '';
    if (!irk_kod && k.irk) {
      const normStr = (s: string) => s.toLowerCase().replace(/\s+/g, ' ').trim();
      const bulunan = irklar.find((i: any) => normStr(i.ad) === normStr(k.irk));
      irk_kod = bulunan ? bulunan.kod : '';
    }
    setSecili(k); setForm({...k, irk_kod}); setHata(''); setModalAcik(true);
  };

  const kaydet = async () => {
    if (!form.isletme_id) { setHata('İşletme seçiniz'); return; }
    if (!form.irk_kod) { setHata('Irk seçiniz'); return; }
    setHata(''); setYukleniyor(true);
    try {
      const body = { ...form, isletme_id: Number(form.isletme_id), irk: irkAdi(form.irk_kod), irk_kod: form.irk_kod };
      if (secili) {
        await axios.put(`${API}/api/hayvancilik/buyukbas/${secili.id}`, body, { headers: headers() });
      } else {
        await hayvancilikApi.buyukbasSave(body);
      }
      yukle(); setModalAcik(false); setSecili(null); setForm({ ...emptyForm });
    } catch (e: any) { setHata(e.response?.data?.detail || 'Hata oluştu'); }
    finally { setYukleniyor(false); }
  };

  const sil = async (id: number) => {
    if (!window.confirm('Bu kaydı silmek istiyor musunuz?')) return;
    try { await hayvancilikApi.buyukbasDelete(id); yukle(); } catch {}
  };

  const silSecili = async (rows: any[]) => {
    for (const k of rows) { try { await hayvancilikApi.buyukbasDelete(k.id); } catch {} }
    yukle();
  };

  const buyukbasColumns: DtColumn[] = [
    { key: 'isletme', label: 'İşletme', sortable: true, filterable: true, render: (k: any) => <><strong>{k.isletme_kod}</strong><br /><small>{k.isletme_ad}</small></>, sortValue: (k: any) => k.isletme_kod || '', filterValue: (k: any) => k.isletme_ad || '', exportValue: (k: any) => `${k.isletme_kod} ${k.isletme_ad}` },
    { key: 'yil', label: 'Yıl', sortable: true, filterable: true, sortValue: (k: any) => Number(k.yil), filterValue: (k: any) => String(k.yil) },
    { key: 'ay', label: 'Ay', sortable: true, filterable: true, render: (k: any) => AYLAR[k.ay] || k.ay, filterValue: (k: any) => AYLAR[k.ay] || String(k.ay), sortValue: (k: any) => Number(k.ay) },
    { key: 'irk', label: 'Irk', sortable: true, filterable: true, render: (k: any) => irkAdDuzelt(k.irk), filterValue: (k: any) => k.irk || '' },
    { key: 'boga_sayisi', label: 'Boğa', sortable: true, render: (k: any) => n(k.boga_sayisi), sortValue: (k: any) => Number(k.boga_sayisi || 0) },
    { key: 'inek_sayisi', label: 'İnek', sortable: true, render: (k: any) => n(k.inek_sayisi), sortValue: (k: any) => Number(k.inek_sayisi || 0) },
    { key: 'genc_boga', label: 'G.Boğa', sortable: true, render: (k: any) => n(k.genc_boga_sayisi), sortValue: (k: any) => Number(k.genc_boga_sayisi || 0) },
    { key: 'duve', label: 'Düve', sortable: true, render: (k: any) => n(k.duve_sayisi), sortValue: (k: any) => Number(k.duve_sayisi || 0) },
    { key: 'dana_erkek', label: 'E.Dana', sortable: true, render: (k: any) => n(k.dana_erkek), sortValue: (k: any) => Number(k.dana_erkek || 0) },
    { key: 'dana_disi', label: 'D.Dana', sortable: true, render: (k: any) => n(k.dana_disi), sortValue: (k: any) => Number(k.dana_disi || 0) },
    { key: 'erkek_buzagi', label: 'E.Buzağı', sortable: true, render: (k: any) => n(k.erkek_buzagi_sayisi), sortValue: (k: any) => Number(k.erkek_buzagi_sayisi || 0) },
    { key: 'disi_buzagi', label: 'D.Buzağı', sortable: true, render: (k: any) => n(k.disi_buzagi_sayisi), sortValue: (k: any) => Number(k.disi_buzagi_sayisi || 0) },
    { key: 'ticari', label: 'Ticari', sortable: true, render: (k: any) => n(k.ticari_sigir_sayisi), sortValue: (k: any) => Number(k.ticari_sigir_sayisi || 0) },
    { key: 'reforme', label: 'Reforme', sortable: true, render: (k: any) => n(k.reforme_sayisi), sortValue: (k: any) => Number(k.reforme_sayisi || 0) },
    { key: 'toplam', label: 'Toplam', sortable: true, render: (k: any) => <strong>{n(k.toplam_hayvan)}</strong>, sortValue: (k: any) => Number(k.toplam_hayvan || 0) },
    { key: 'sut', label: 'Süt (kg)', sortable: true, render: (k: any) => n(k.sut_uretimi_kg), sortValue: (k: any) => Number(k.sut_uretimi_kg || 0) },
    { key: 'islem', label: 'İşlem', noExport: true, render: (k: any) => (
      <div style={{ display: 'flex', gap: 4 }}>
        {isAdmin && <button className="btn btn-primary btn-sm" onClick={() => duzenleAc(k)}>Düzenle</button>}
        <button className="btn btn-danger btn-sm" onClick={() => sil(k.id)}>Sil</button>
      </div>
    )},
  ];

  const excelYukle = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]; if (!file) return;
    e.target.value = '';
    await excelGonder(file, '');
  };

  const excelGonder = async (file: File, cakisma: string) => {
    setExcelMesaj('Yükleniyor...');
    try {
      const res = await hayvancilikApi.buyukbasExcel(file, cakisma);
      if (res.data.bekliyor) {
        setBekleyenDosya(file);
        setCakismalar(res.data.cakismalar);
        setCakismaYeniSayisi(res.data.yeni_sayisi);
        setCakismaModal(true);
        setExcelMesaj('');
        return;
      }
      setExcelMesaj(`✅ ${res.data.basarili} kayıt aktarıldı${res.data.hatali_sayisi > 0 ? `, ${res.data.hatali_sayisi} hata` : ''}`);
      yukle();
    } catch { setExcelMesaj('❌ Excel yüklenemedi'); }
  };

  const cakismaKarar = async (karar: 'yaz' | 'atla') => {
    if (!bekleyenDosya) return;
    setCakismaModal(false);
    await excelGonder(bekleyenDosya, karar);
    setBekleyenDosya(null);
  };

  const n = (v: any) => (v ?? 0).toLocaleString('tr-TR');

  return (
    <div>
      {cakismaModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center' }}>
          <div style={{ background:'#fff', borderRadius:8, padding:28, width:520, maxWidth:'95vw', maxHeight:'80vh', display:'flex', flexDirection:'column', gap:16 }}>
            <div style={{ fontWeight:700, fontSize:16, color:'#c0392b' }}>⚠️ Mevcut Kayıtlar Bulundu</div>
            <div style={{ fontSize:13, color:'#555' }}>
              Aşağıdaki <strong>{cakismalar.length} kayıt</strong> sistemde zaten mevcut.
              {cakismaYeniSayisi > 0 && <span> Yeni kayıt sayısı: <strong>{cakismaYeniSayisi}</strong>.</span>}
            </div>
            <div style={{ overflowY:'auto', maxHeight:300, border:'1px solid #eee', borderRadius:4 }}>
              {cakismalar.map((c, i) => (
                <div key={i} style={{ padding:'6px 10px', borderBottom:'1px solid #f0f0f0', fontSize:12, color:'#333' }}>
                  Satır {c.satir}: {c.ozet}
                </div>
              ))}
            </div>
            <div style={{ display:'flex', gap:10, justifyContent:'flex-end', flexWrap:'wrap' }}>
              <button className="btn" style={{ background:'#e74c3c', color:'#fff' }} onClick={() => cakismaKarar('yaz')}>
                Üzerine Yaz
              </button>
              <button className="btn" style={{ background:'#27ae60', color:'#fff' }} onClick={() => cakismaKarar('atla')}>
                Atla (Sadece Yenileri Ekle)
              </button>
              <button className="btn" style={{ background:'#95a5a6', color:'#fff' }} onClick={() => { setCakismaModal(false); setBekleyenDosya(null); setExcelMesaj('İptal edildi'); }}>
                İptal
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="page-header">
        <h1>🐄 Büyükbaş Hayvancılık</h1>
        <p>İşletme bazında aylık büyükbaş hayvan verileri</p>
      </div>

      {ozet && (
        <div className="stats-grid">
          <div className="stat-card"><div className="stat-icon">🐄</div><div><div className="stat-value">{n(ozet.toplam_hayvan)}</div><div className="stat-label">Toplam Hayvan</div></div></div>
          <div className="stat-card"><div className="stat-icon">🥛</div><div><div className="stat-value">{n(Math.round(ozet.toplam_sut_kg))}</div><div className="stat-label">Süt Üretimi (kg)</div></div></div>
          <div className="stat-card"><div className="stat-icon">🐮</div><div><div className="stat-value">{n(ozet.toplam_buzagi)}</div><div className="stat-label">Buzağı Doğumu</div></div></div>
          <div className="stat-card"><div className="stat-icon">💰</div><div><div className="stat-value">{n(ozet.toplam_satis)}</div><div className="stat-label">Satış (Baş)</div></div></div>
        </div>
      )}

      <div className="card">
        <div className="toolbar">
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <input type="number" className="search-input" style={{ width: 90 }} value={filtre.yil}
              onChange={e => setFiltre({ ...filtre, yil: Number(e.target.value) })} placeholder="Yıl" />
            <select className="search-input" style={{ width: 130 }} value={filtre.ay}
              onChange={e => setFiltre({ ...filtre, ay: e.target.value })}>
              <option value={GUNCEL_AY}>Güncel Ay{cozulenAy ? ` (${AYLAR[cozulenAy]})` : ''}</option>
              <option value="">Tüm Aylar</option>
              {AYLAR.slice(1).map((a, i) => <option key={i+1} value={i+1}>{a}</option>)}
            </select>
            {isGM && (
              <>
                <select className="search-input" style={{ width: 200 }} value={filtre.isletme_id}
                  onChange={e => setFiltre({ ...filtre, isletme_id: e.target.value })}>
                  <option value="">Tüm İşletmeler</option>
                  {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
                </select>
                <label style={{ display:'flex', alignItems:'center', gap:4, fontSize:13, cursor:'pointer', whiteSpace:'nowrap' }}>
                  <input type="checkbox" checked={kiralikGoster} onChange={e => setKiralikGoster(e.target.checked)} />
                  Kiralıkları Göster
                </label>
              </>
            )}
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            {excelMesaj && <span style={{ fontSize: 12, color: '#555' }}>{excelMesaj}</span>}
            <label className="btn" style={{ background: '#2ecc71', color: 'white', cursor: 'pointer' }}>
              📥 Excel Yükle
              <input type="file" accept=".xlsx,.xls" style={{ display: 'none' }} onChange={excelYukle} />
            </label>
            <button className="btn btn-success" onClick={() => { setForm({ ...emptyForm, isletme_id: filtre.isletme_id || (isGM ? '' : user?.isletme_id) }); setHata(''); setModalAcik(true); }}>+ Yeni Kayıt</button>
          </div>
        </div>

        <DataTable columns={buyukbasColumns} data={kayitlar} rowKey={(k: any) => k.id} onDeleteSelected={silSecili} exportFilename="buyukbas-hayvancilik" />
      </div>

      {modalAcik && (
        <div className="modal-overlay" onClick={() => setModalAcik(false)}>
          <div className="modal" style={{ width: 620 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>🐄 Büyükbaş Kayıt Girişi</h3>
              <button className="modal-close" onClick={() => setModalAcik(false)}>×</button>
            </div>
            <div className="modal-body">
              {hata && <div className="alert alert-danger">{hata}</div>}

              <div className="form-row">
                {isGM && (
                  <div className="form-group">
                    <label>İşletme *</label>
                    <select className="form-control" value={form.isletme_id}
                      onChange={e => setForm({ ...form, isletme_id: e.target.value })}>
                      <option value="">Seçiniz</option>
                      {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
                    </select>
                  </div>
                )}
                <div className="form-group">
                  <label>Irk * <small style={{color:'#999', fontWeight:'normal'}}>({irklar.length} tanım yüklendi)</small></label>
                  <select className="form-control" value={form.irk_kod}
                    onChange={e => setForm({ ...form, irk_kod: e.target.value })}>
                    <option value="">Seçiniz</option>
                    {irklar.map(irk => (
                      <option key={irk.kod} value={irk.kod}>
                        {irk.ad} ({irk.kod})
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Yıl *</label>
                  <input className="form-control" type="number" value={form.yil}
                    onChange={e => setForm({ ...form, yil: Number(e.target.value) })} />
                </div>
                <div className="form-group">
                  <label>Ay *</label>
                  <select className="form-control" value={form.ay}
                    onChange={e => setForm({ ...form, ay: Number(e.target.value) })}>
                    {AYLAR.slice(1).map((a, i) => <option key={i+1} value={i+1}>{a}</option>)}
                  </select>
                </div>
              </div>

              <p style={{ fontWeight: 'bold', fontSize: 13, color: '#1a5276', marginBottom: 8 }}>Hayvan Varlığı</p>
              <div className="form-row">
                <div className="form-group"><label>Boğa (Baş)</label><input className="form-control" type="number" value={form.boga_sayisi} onChange={e => setForm({ ...form, boga_sayisi: Number(e.target.value) })} /></div>
                <div className="form-group"><label>İnek (Baş)</label><input className="form-control" type="number" value={form.inek_sayisi} onChange={e => setForm({ ...form, inek_sayisi: Number(e.target.value) })} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Genç Boğa (Baş)</label><input className="form-control" type="number" value={form.genc_boga_sayisi} onChange={e => setForm({ ...form, genc_boga_sayisi: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Düve (Baş)</label><input className="form-control" type="number" value={form.duve_sayisi} onChange={e => setForm({ ...form, duve_sayisi: Number(e.target.value) })} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Erkek Dana (Baş)</label><input className="form-control" type="number" value={form.dana_erkek} onChange={e => setForm({ ...form, dana_erkek: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Dişi Dana (Baş)</label><input className="form-control" type="number" value={form.dana_disi} onChange={e => setForm({ ...form, dana_disi: Number(e.target.value) })} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Erkek Buzağı (Baş)</label><input className="form-control" type="number" value={form.erkek_buzagi_sayisi} onChange={e => setForm({ ...form, erkek_buzagi_sayisi: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Dişi Buzağı (Baş)</label><input className="form-control" type="number" value={form.disi_buzagi_sayisi} onChange={e => setForm({ ...form, disi_buzagi_sayisi: Number(e.target.value) })} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Ticari Sığır (Besi-Kasaplık)</label><input className="form-control" type="number" value={form.ticari_sigir_sayisi} onChange={e => setForm({ ...form, ticari_sigir_sayisi: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Reforme Baş</label><input className="form-control" type="number" value={form.reforme_sayisi} onChange={e => setForm({ ...form, reforme_sayisi: Number(e.target.value) })} /></div>
              </div>

              <p style={{ fontWeight: 'bold', fontSize: 13, color: '#1a5276', marginBottom: 8, marginTop: 12 }}>Süt Üretimi</p>
              <div className="form-row">
                <div className="form-group"><label>Yıllık Süt Üretim (kg)</label><input className="form-control" type="number" value={form.sut_uretimi_kg} onChange={e => setForm({ ...form, sut_uretimi_kg: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Ana Hayvan Sayısı (baş)</label><input className="form-control" type="number" value={form.ana_hayvan_sayisi} onChange={e => setForm({ ...form, ana_hayvan_sayisi: Number(e.target.value) })} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Sağmal Hayvan Sayısı (baş)</label><input className="form-control" type="number" value={form.sagmal_hayvan_sayisi} onChange={e => setForm({ ...form, sagmal_hayvan_sayisi: Number(e.target.value) })} /></div>
                <div className="form-group" />
              </div>

              <p style={{ fontWeight: 'bold', fontSize: 13, color: '#1a5276', marginBottom: 8, marginTop: 12 }}>Doğum / Ölüm / Satış</p>
              <div className="form-row">
                <div className="form-group"><label>Buzağı Doğum</label><input className="form-control" type="number" value={form.buzagi_dogum} onChange={e => setForm({ ...form, buzagi_dogum: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Buzağı Ölüm</label><input className="form-control" type="number" value={form.buzagi_olum} onChange={e => setForm({ ...form, buzagi_olum: Number(e.target.value) })} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Damızlık Satış</label><input className="form-control" type="number" value={form.damizlik_satis} onChange={e => setForm({ ...form, damizlik_satis: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Besi Satış</label><input className="form-control" type="number" value={form.besi_satis} onChange={e => setForm({ ...form, besi_satis: Number(e.target.value) })} /></div>
              </div>
              <div className="form-group"><label>Açıklama</label><textarea className="form-control" value={form.aciklama} onChange={e => setForm({ ...form, aciklama: e.target.value })} rows={2} /></div>
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={() => setModalAcik(false)} style={{ background: '#eee' }}>İptal</button>
              <button className="btn btn-primary" onClick={kaydet} disabled={yukleniyor}>
                {yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
